import React from "react"
import Button from "../Elements/Button"

const ThanksSection = () => {
    return (
        <div>
            <div className="login-heading">
                <h2 className="color-blue"><span className="green-checkmark"></span> THANK YOU !</h2>
            </div>
            <div className="thankyou-para">
                <div>
                    <p>
                        Thanks for signing up.
                        You're going to love this amazing service.
                    </p>
                </div>
                <div>
                    <p>
                        A confirmation link has been emailed to you.
                    </p>
                </div>
                <div>
                    <p>
                        Check your email, click on the included link,
                        and get ready to put your content to work!
                    </p>
                </div>
                <div className=" text-center">
                    <Button
                        text={'Ok'}
                        classList={'success'}
                        onClick={() => window.location.href = "/"}
                    />
                </div>
                <div className="resend-link mt-3">
                    <p>
                        Didn’t receive a link?  <a href="/users/confirmation/new">Resend</a>
                    </p>
                   
                </div>
            </div>
        </div>
    )
}
export default ThanksSection